import { IScriptExecuteBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanScriptExecutable } from "../../../beans/objects";
import { ItemsTranslator } from "./ItemsTranslator";
import { IntegerTranslator, StringTranslator } from "../../values";

export class ScriptExecuteBehaviorTranslator {
  from(bean: IObjectBeanScriptExecutable): IScriptExecuteBehavior {
    return {
      timing: this.integer.from(bean["@update"]),
      scriptPath: this.string.from(bean["@exe-path"]),
      separator: this.string.from(bean["@split"]),
      parameters: this.items.from(
        bean.scriptitem,
        s => {
          const isFixed = (s["@item-type"] === "2");
          return {
            isFixed,
            parameter: this.string.from(isFixed ? s["@value"] : s["@key"]),
          };
        },
      ),
      csvFilePathFormat: this.string.from(bean["@csv-path"]),
      valuesXmlPathFormat: this.string.from(bean["@value-path"]),
      previousValuesCsvFilePathFormat: this.string.from(bean["@before-value-path"]),
    };
  }

  to(object: IScriptExecuteBehavior) {
    return {
      update: this.integer.to(object.timing),
      exePath: this.string.to(object.scriptPath),
      split: this.string.to(object.separator),
      scriptitem: this.items.to(
        object.parameters,
        s => ({
          "@name": "",   // 使ってない？空文字固定.
          "@item-type": s.isFixed ? "2" : "1",
          "@key": s.isFixed ? "" : this.string.to(s.parameter),
          "@value": s.isFixed ? this.string.to(s.parameter) : "",
        })
      ),
      csvPath: this.string.to(object.csvFilePathFormat),
      valuePath: this.string.to(object.valuesXmlPathFormat),
      beforeValuePath: this.string.to(object.previousValuesCsvFilePathFormat),
    };
  }

  private readonly string = new StringTranslator();
  private readonly items = new ItemsTranslator();
  private readonly integer = new IntegerTranslator();
}
